import React, { useRef } from "react";
import emailjs from "emailjs-com";
import "./Contact.scss";

const Contact = ({ componentOffsetTop }) => {
  const values = useRef([]);
  const sendEmail = (event) => {
    event.preventDefault();
    values.current[3].value = "Sending Message . . .";
    emailjs
      .sendForm(
        "service_u29dm7l",
        "template_4Gnr2qTr",
        event.target,
        "user_fgUkj2XhE8869QqxOXUo0"
      )
      .then(
        (result) => {
          alert("Thanks for your message!");
          values.current[3].value = "SEND MESSAGE";
        },
        (error) => {
          console.log(error.text);
        }
      );
    event.target.reset();
  };
  return (
    <div
      id="contact"
      className="contact"
      ref={(e) => (componentOffsetTop.current[7] = e)}
    >
      <form className="contact-form" onSubmit={(e) => sendEmail(e)}>
        <div>
          <h1>CONTACT WITH ME</h1>
        </div>
        <div>
          <input
            name="Name"
            type="text"
            placeholder="Full Name"
            ref={(e) => (values.current[0] = e)}
            spellCheck="false"
            autoComplete="off"
            required
          ></input>
          <input
            name="Email"
            type="email"
            placeholder="Email"
            ref={(e) => (values.current[1] = e)}
            autoComplete="off"
            spellCheck="false"
            required
          ></input>
          <textarea
            name="Message"
            placeholder="Message"
            ref={(e) => (values.current[2] = e)}
            autoComplete="off"
            spellCheck="false"
            required
          ></textarea>
          <input
            type="submit"
            value="Send Message"
            ref={(e) => (values.current[3] = e)}
          />
        </div>
      </form>
    </div>
  );
};

export default Contact;
